import React from "react"
import Icon from "components/ui/Icon"
import SubTitle from "components/ui/SubTitle"
import TextContent from "components/ui/TextContent"

import * as Styled from "./styles"

interface Props {
  icon: React.ReactComponentElement<any>
  title1: string
  title2: string
  content: string
}

const IconInfoBlock: React.FC<Props> = ({ icon, title1, title2, content }) => (
  <Styled.Wrapper>
    <Icon>{icon}</Icon>
    <Styled.TitleWrapper>
      <SubTitle>{title1}</SubTitle>
      <SubTitle lighter>{title2}</SubTitle>
    </Styled.TitleWrapper>
    <TextContent center>{content}</TextContent>
  </Styled.Wrapper>
)

export default IconInfoBlock
